<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const polotno = options.polotno || {
        'Стандарт': 'Стандарт',
        'а/к бронза Bronze Shine': 'а/к бронза Bronze Shine',
        'а/к бронза White Shine': 'а/к бронза White Shine',
        'а/к серая':'а/к серая',
        'а/к черная': 'а/к черная',
        'светоотраж Sunlight':'светоотраж Sunlight',
        'а/п Micro Mesh черная':'а/п Micro Mesh черная',
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind1 = item.title.includes('без перемычки') ? 'Нет' : 'Есть';
            ind2.set(title[2]);
            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            ind6 = item.title.includes('19 мм') ? 'ПВХ окно 19 мм' : (item.title.includes('20 мм') ? 'ПВХ окно 20 мм' :'AL окно');
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый(9016RAL)':'Белый(9016RAL)',
        'Коричневый(8017RAL)':'Коричневый(8017RAL)',
        'Антрацит(7016RAL)':'Антрацит(7016RAL)',
        'Антрацит (7016 муар)':'Антрацит (7016 муар)',
        'Сублимация':'Сублимация',
        'Чёрный':'Чёрный',
        'Цветной':'Цветной',
    }

    const fetch = async () => {
        let result = await network.fetch_data('USN', '', '');
        let options = await network.fetch_ind('USN');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        ind1 = 'Есть', // перемычка
        ind2 = parameter('color', Object.values(color).shift()), // цвет
        ind3 = 'стандарт', // полотно
        ind6 = 'ПВХ окно 19 мм', // ручки

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);
    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {fetchData = fetch($ind2)};
    const changeHeight = _.debounce(() => {
        if ($height > 1400 && ind1 !== 'Есть') {
            ind1 = 'Есть';
            toastbox('toast-ind1', 3000);
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height;


        let result = {
            type: 'USN',
            name: 'USN',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                ', ручка на ' + ind6,
            ].join(''),
            title: [
                'USN', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                ', ручка на ' + ind6,
            ].join(''),
            params: {
                 ind1: [
                     ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                     ', ручка на ' + ind6,
                 ].join(''),
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,

            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 82,
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль') && (item.ind2.toLowerCase().includes($ind2.toLowerCase()))) {
                kolvo = (((w +34) * 2 + (h +34) * 2) / 1000).toFixed(3);
            }
            if (name.includes('шнур 4 мм') && (ind3.includes('а/к') || ind3.includes('а/п'))){
                kolvo = (((w +10) * 2 + (h +10) * 2) / 1000).toFixed(3);
            }
            if (name.includes('шнур 5 мм') && (!(ind3.includes('а/к') || ind3.includes('а/п')))){
                kolvo = (((w +10) * 2 + (h +10) * 2) / 1000).toFixed(3);
            }
            if (name.includes('уплотнитель')){
                kolvo = (((w +15) * 2 + (h +15) * 2) / 1000).toFixed(3);
            }
            if (name.includes('перемычка')) {
                if (ind1 === 'Есть') {
                    kolvo = ((w - 17) / 1000).toFixed(3);
                }
            }
            if (name.indexOf(ind3.toLowerCase()) >= 0) {
                kolvo = ((w + 34) * (h + 34)/ 1000000).toFixed(3);
            }
            if (name.includes('работа стандарт') && (!(ind3.includes('а/к') || ind3.includes('а/п')))) {
                kolvo = (1).toFixed(3);
            }
            if (name.includes('работа сложная ') && ((ind3.includes('а/к') || ind3.includes('а/п')))) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('крепление мс перемычки')) {
                if (ind1 === 'Есть') {
                    kolvo = (2).toFixed(3);
                }
            }

            if (name.includes('ручка фиксатор')  && (item.ind2.toLowerCase().includes(ind6.toLowerCase())) ) {
                kolvo = (4).toFixed(3);
               //console.log('!!!  '+ h + ' '+  name);

                if (h > 1500 && name.includes('al')){
                   //console.log('!111!!')
                    kolvo = 6;
                }
            }

            if (name.includes('угол')) {
                kolvo = (4).toFixed(3);
            }

            if (kolvo) {

                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }


        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">



            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each _.sortBy(data.edIzmer['кв.м'], 'name') as item}
                                {#if item.flag == 1}
                                    <option value="{item.name.replace('Сетка', '').trim()}">{item.name.replace('Сетка', '').trim()}</option>
                                {/if}
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-12">
                <div class="form-group boxed">
                     <div class="alert alert-outline-danger">
                         К расчету принимаются только размеры светового проема!
                     </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 1300 }</label>
                        <input type="number" class="form-control" step="10" min="200" max="{ options.max && options.max.width ? options.max.width : 1300 }" bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 2400 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.height ? options.max.height : 2400 }" bind:value={$height} use:validate_int={$height} on:change={changeHeight}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="Есть">Есть</option>
                            <option value="Нет">Нет</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
        </div>



        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ручка на</label>
                        <select class="form-control form-select" bind:value={ind6}>
                            <option value="AL окно">AL окно</option>
                            <option value="ПВХ окно 19 мм">ПВХ окно 19 мм</option>
                            <option value="ПВХ окно 20 мм">ПВХ окно 20 мм</option>
                        </select>
                    </div>
                </div>
            </div>

            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
